require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-03-27-traveling.json") })
        }
      }, "path---articles-2008-03-27-traveling");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-03-27-traveling!./.cache/json/articles-2008-03-27-traveling.json
// module id = 546
// module chunks = 231608221292675